module.exports = __webpack_public_path__ + "res/roboto-v15-latin-100.woff";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/googlefonts/roboto-v15-latin-100.woff
// module id = 95
// module chunks = 1